import angular from 'angular';
import sendMail from './sendMail';

export default angular
  .module('components.sendMail', [])
  .component('sendMail', sendMail).name;
